import { parse } from 'graphql'
import { useQuery } from 'glimmer-apollo'
import { isDestroying, isDestroyed } from '@ember/destroyable'
import type { ApolloQueryResult } from '@apollo/client/core'
import { throwClassifiedFetchError } from 'customer-flows/gql/queries/availability-errors'

export type BundleAvailabilityVariables = {
  quoteId: string
  bundleId: string
}

export type BundleAvailabilityResponse = {
  bundleAvailability:
    | { __typename: 'BundleAvailabilitySuccess'; bundleItemsAvailability: BundleItemAvailability[] }
    | GenericError
    | NotFoundError
}

export async function fetchBundleAvailability(
  context: Object,
  variables: BundleAvailabilityVariables
): Promise<ApolloQueryResult<BundleAvailabilityResponse> | undefined> {
  if (isDestroying(context) || isDestroyed(context)) return undefined

  const availabilityQuery = useQuery<BundleAvailabilityResponse, { input: BundleAvailabilityVariables }>(context, () => [
    query,
    {
      fetchPolicy: 'no-cache', // availability is large and changes often, same as the availability queries
      variables: { input: variables },
      onError: (error) => throwClassifiedFetchError('Failed to fetch bundle availability', error)
    }
  ])

  return availabilityQuery.refetch()
}

const query = parse(`
  query BundleAvailability($input: BundleAvailabilityInput!) {
    bundleAvailability(input: $input) {
      __typename
      ... on BundleAvailabilitySuccess {
        bundleItemsAvailability {
          bundleItemId
          activityId
          availabilityDates {
            date
            status
            availabilityTimes {
              activityId
              from
              time
              status
            }
          }
        }
      }
      ... on NotFoundError {
        message
      }
      ... on GenericError {
        message
      }
    }
  }
`)
